import type {
  AlignItemsProps,
  GridProps as SystemGridProps,
  JustifyContentProps,
  JustifyItemsProps,
} from 'styled-system';

import type { BoxProps } from '@/components/Box';
import type { GridGapDensity, Space } from '@/theme/types';

import * as S from './Row.styles';

export interface RowProps
  extends Omit<
      SystemGridProps,
      'gridGap' | 'gridColumnGap' | 'gridRowGap' | 'gridTemplateColumns'
    >,
    AlignItemsProps,
    JustifyContentProps,
    JustifyItemsProps,
    BoxProps {
  children: React.ReactNode;
  gapDensity?: GridGapDensity;
  showRowGap?: boolean;
  spacing?: Space;
}

export const Row = ({ as, children, gapDensity, ...rest }: RowProps) => {
  return (
    <S.Row
      alignItems='center'
      forwardedAs={as}
      gapDensity={gapDensity}
      {...rest}
    >
      {children}
    </S.Row>
  );
};

export const defaultRowProps: Required<Pick<RowProps, 'gapDensity' | 'as'>> = {
  as: 'div',
  gapDensity: 'normal',
};

Row.displayName = 'Row';
